import React from "react";

const InfoCard = ({
  heading,
  number,
  icon: Icon,
  bottomText,
  iconColor = "text-gray-500", // default color
  bgColor = "bg-gray-100", // default background color
}) => {
  return (
    <div className="p-6 bg-white shadow rounded-lg flex flex-col justify-between border border-gray-200 ">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-md text-gray-900">{heading}</h2>
          <p className="text-3xl font-bold text-gray-900">{number}</p>
        </div>
        <div className="flex-shrink-0">
          {/* Icon Section */}
          <div className={`${bgColor} p-3 sm:p-4 rounded-full`}>
            {typeof Icon === "string" ? (
              <img src={Icon} alt="" className="h-full w-auto object-contain" />
            ) : (
              <Icon className={`w-10 h-10 sm:w-12 sm:h-12 ${iconColor}`} />
            )}
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-600 mt-8">{bottomText}</p>
    </div>
  );
};

export default InfoCard;
